import {View} from '@fantasmagames/slot/src/common/view/View';
import {Module} from '@fantasmagames/slot/src/common/Module';

interface IFunctionMap {
	[name: string]: Function;
}

interface IKeyMap {
	[key: string]: IKeyItem;
}

interface IKeyItem {
	name: string;
	options: IKeyOptions;
}

interface IKeyOptions {
	shiftKey: boolean;
	altKey: boolean;
	ctrlKey: boolean;
}

// TODO: DI this maybe? To keep a single keyboard input setup and better track of keys.
// Listen to events? Add event handler?
export class DebuggingComponent {
	protected _view: View;
	protected _module: Module<any>;

	protected _hasAddedKeyboardInput: boolean = false;

	protected _keyMap: IKeyMap;

	protected _functionMap: IFunctionMap;

	constructor(mod: Module<any>, view?: View) {
		this._keyMap = {};
		this._functionMap = {};
		this._module = mod;
		this._view = view;

		this.init();
	}

	public init(): void {
	}

	public addKeyFunction(
		key: string,
		name: string,
		callback: Function,
		keyOptions: IKeyOptions = {shiftKey: false, altKey: false, ctrlKey: false},
	): void {
		this._keyMap[key] = {name, options: keyOptions};
		this._functionMap[name] = callback;
	}

	public addFunction(name: string, callback: Function): void {
		this._functionMap[name] = callback;
	}

	/**
	 * Adds a window call function. To use: window['name'](...args);
	 *
	 * @param {string} name
	 * @param {Function} func
	 * @memberof DebuggingComponent
	 */
	public addWindowFunction(name: string, func: Function): void {
		(window as any)[name] = func;

		if (!(window as any).debuggingFunctions && typeof (window as any).debuggingFunctions !== 'object') {
			(window as any).debuggingFunctions = [];
		}

		(window as any).debuggingFunctions.push(name);
	}

	/**
	 * Adds keyboardinput.
	 * @memberof DebuggingComponent
	 */
	public setupInput(): void {
		if (!this._hasAddedKeyboardInput) {
			this._hasAddedKeyboardInput = true;
			document.addEventListener('keydown', this.keyboardInput.bind(this));
		}
	}

	protected keyboardInput(event: KeyboardEvent): void {
		this.runKeyFunction(event.code, {altKey: event.altKey, ctrlKey: event.ctrlKey, shiftKey: event.shiftKey});
	}

	public runKeyFunction(key: string, keyOptions: IKeyOptions): void {
		if (this._keyMap[key] && this.compareOptions(this._keyMap[key].options, keyOptions)) {
			this._functionMap[this._keyMap[key].name]();
		}
	}

	protected compareOptions(base: IKeyOptions, comparison: IKeyOptions): boolean {
		return base.altKey === comparison.altKey && base.ctrlKey === comparison.ctrlKey && base.shiftKey === comparison.shiftKey;
	}

	public runFunction(name: string): void {
		if (this._functionMap[name] && this._functionMap[name].call) {
			this._functionMap[name]();
		}
	}

	public logAllKeys(): void {
		for (const item in this._keyMap) {
			if (this._keyMap.hasOwnProperty(item)) {
				const element = this._keyMap[item];
				console.log(element);
			}
		}
	}

	public logAllFunctions(): void {
		this._functionMap.forEach((item) => {
			console.log(item);
		});
	}

	public get view(): View {
		return this._view;
	}

	public get module(): Module<any> {
		return this._module;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/debugging/DebuggingComponent.ts